import { ErrorHandler, inject, Service } from '@angular/core';
import { MonitoringService } from '../services/monitoring.service';
import { SnackbarService } from '../services/snackbar';

@Service()
export class ErrorHandlerService implements ErrorHandler {
    private readonly monitoringService = inject(MonitoringService);
    private readonly snackbarService = inject(SnackbarService);

    public handleError(error: any): void {
        this.monitoringService.logException(error);
        console.error(error);

        if (this.isChunkLoadError(error)) {
            let snackbar = this.snackbarService.open('str_common_newVersion_message', 'info', {}, 'str_common_newVersion_action', false, -1);

            snackbar.instance.onAction.subscribe(() => {
                window.location.reload();
            });
        }
    }

    private isChunkLoadError(error: any): boolean {
        return error.message && (error.message.includes('Failed to fetch dynamically imported module') || error.message.includes('error loading dynamically imported module'));
    }
}
